import React from 'react';
import styled from 'styled-components';
import { Droppable } from 'react-beautiful-dnd';
import { ProgressBar } from 'react-bootstrap';
import Task from './Task';
import '../assets/css/task.css';
import '../assets/css/challenge.css';
import blueShape from '../assets/images/blue-shape.png';
import blueShapeBanner from '../assets/images/purple-bg.png';
import challengeImage from '../assets/images/qpage-banner-img.png';
import cgInventLogo from '../assets/images/Invent_Logo_2COL_RGB.svg';
import returnJSX from '../components/ReturnJSX';
import returnHint from './ReturnHint';


const Container = styled.div`
  

`;
const Title = styled.h3`
  padding: 8px;
`;
const TaskList = styled.div`
  padding: 8px;
`;

export default class Column extends React.Component {
  render() {

    // console.log(this.props.column);
    return (
      <Container>
        <div className="challenge-banner d-flex">
          <div className="cg-logo">
                    <img src={cgInventLogo} alt="Capgemini Logo" width="150" />
                </div>
          <img className="challenge-banner-img" src={challengeImage} alt="Challenge page banner image" />
          
          <div className="white-text-box d-flex">
            <div className="d-flex header-white-txt">
              <h5>
                {this.props.order} of 10
                <ProgressBar now={(this.props.order) * 10} />
              </h5>
              <h4 className="thankyou-h4">{this.props.column.title}</h4>
            </div>
          </div>
        </div>
        <p className="blue-text p-2 blue-text-resp">
          {returnJSX(this.props.column.description)}
          <i>&nbsp;{returnHint(this.props.column.hint)}</i>
        </p>
        <Droppable droppableId={this.props.column.id}>
          {(provided) => (
            <TaskList ref={provided.innerRef} {...provided.droppableProps} >
              {this.props.tasks.map((task, index) => (
                <Task key={task.sid} task={task} index={index} />
              ))}
              {provided.placeholder}
            </TaskList>
          )}
        </Droppable>
      </Container>
    );
  }
}
